import { Component, OnInit, Input } from '@angular/core';

import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { Observable, firstValueFrom } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

import { ApiUploadedFile, ApiSetUploadedFilesRequest } from '../../api-client-module/';

import { ApiClientService } from '../../api-client.service';
import { ConfigurationService } from '../../configuration.service';
import { SpinnerService } from '../../services/spinner.service';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

import imageCompression from 'browser-image-compression';

@Component({
  selector: 'app-upload-task',
  templateUrl: './upload-task.component.html',
  styleUrls: ['./upload-task.component.css'],
  standalone: false,
})
export class UploadTaskComponent implements OnInit {

  @Input() file!: File;
  @Input() compless!: string;
  @Input() type?: string = '';
  @Input() attributeIds?: Array<string> = [];

  task!: AngularFireUploadTask;

  percentage!: Observable<number>;
  snapshot!: Observable<any>;
  downloadURL!: string;

  compressOption1 = {
    maxSizeMB: 0.5,
    maxIteration: 20,
    alwaysKeepResolution: true
  };

  compressOption2 = {
    maxWidthOrHeight: 640
  };

  constructor(
    private storage: AngularFireStorage,
    private spinnerService: SpinnerService,
    private apiClientService: ApiClientService,
    private configurationService: ConfigurationService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.startUpload();
  }

  //アップロード開始
  async startUpload() {
    this.spinnerService.openSpinner();
    let compressFile = this.file;
    if (this.file.type.startsWith("image/") && this.compless != "9") {
      if (this.compless == "1") {
        compressFile = await imageCompression(this.file, this.compressOption1);
      } else {
        compressFile = await imageCompression(this.file, this.compressOption2);
      }
    }
    const fileName = `${Date.now()}_${this.file.name}`;
    let dir = AppConst.FILE_UPLOAD_DIR_NAME;
    if (this.type == 'DL') {
      dir = AppConst.FILE_UPLOAD_DL_DIR_NAME;
    }
    const path = `${AppConst.FILE_UPLOAD_ROOT_DIR_NAME}/${this.configurationService.getProjectId()}/${dir}/${fileName}`;
    const ref = this.storage.ref(path);

    // this.task = this.storage.upload(path, this.file);
    this.task = this.storage.upload(path, compressFile);
    this.percentage = this.task.percentageChanges() as any;
    this.snapshot = this.task.snapshotChanges().pipe(
      tap(console.log),
      finalize( async() =>  {
        this.downloadURL = await firstValueFrom(ref.getDownloadURL());
        let uploedFile:ApiUploadedFile = {
          type: this.type ? this.type : '',
          file_name: fileName,
          file_path: path,
          download_url: this.downloadURL,
          project_id: this.configurationService.getProjectId(),
          enabled: true,
          attribute_ids: this.attributeIds && this.attributeIds.length > 0 ? this.attributeIds : undefined
        };
        let request: ApiSetUploadedFilesRequest = {
          access_token: '',
          change_type: AppConst.DATA_CHANGE_TYPE_ADD,
          uploaded_files: [uploedFile]
        }
        this.apiClientService.setUploadedFiles(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('アップロード完了'))
            } else {
              this.toastr.error(this.translate.instant('アップロードできませんでした。'))
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('アップロードできませんでした。'));
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      })
    );
  }

  // isActive(snapshot) {
  //   return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes;
  // }

}
